import React from "react";
import { CustomLabel, typeOfCal } from "../../Constant";
import CustomInput from "../../elements/CustomInput";
import DropdownCardComponent from "../DropdownCardComponent";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircle,
  faCircleInfo,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import CI_PAdropdownComponent from "../Ci_PA_Component";

const InputComponent = ({
  label,
  extraData = false,
  dropdownComponent = false,
  ...props
}) => {
  const typeOfCalculator = useSelector((state) => state.common.type);
  const text = `Family Floater = 2 Adults only (Any one member should be >= 56 Years)
  Multi Individual = Up to 8 Members (All members should be >=56 Years)
  `;
  return (
    <>
      <div className=" mb-2 position-relative d-inline-block">
        <CustomLabel font_size="12">
          {label} &nbsp; &nbsp;
          {extraData && (
            <CustomLabel font_size="12" color="#c3c2c2">
              This will be register on your policy
            </CustomLabel>
          )}
        </CustomLabel>
        {typeOfCalculator === typeOfCal.primeSenior && dropdownComponent && (
          <Tooltip title={text}>
            <FontAwesomeIcon
              icon={faCircleInfo}
              style={{ color: "#0184c9", width: "13px" }}
            />
          </Tooltip>
        )}
      </div>
      <div className="position-relative">
        <CustomInput {...props} />
        {(typeOfCalculator === typeOfCal.ci || typeOfCalculator === typeOfCal.pa || typeOfCalculator === typeOfCal.accident_Shield || typeOfCalculator === typeOfCal.mchiSarvah)
          ? dropdownComponent && <CI_PAdropdownComponent {...props} />
          : dropdownComponent && <DropdownCardComponent {...props} />}
      </div>
    </>
  );
};

export default InputComponent;
